import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-188d436e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Versiones maestros")
const _hoisted_2 = { class: "version" }
const _hoisted_3 = { class: "total" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Actualizar maestros")

import { onMounted } from 'vue'
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonButton,
  modalController,
  IonText,
  IonItem,
  IonLabel,
  IonList,
  loadingController
} from '@ionic/vue'

// import { exportDatabase } from '@/db/sqlite'
import { useSyncStore } from '@/store/sync'

import IonicIcon from '@/components/IonicIcon.vue'
import { useControlStore } from '@/store/control'


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncDataView',
  setup(__props) {

const syncStore = useSyncStore()
const controlStore = useControlStore()

onMounted(async () => await syncStore.getVersions())

const syncData = async () => {
  if (navigator.onLine) {
    const loading = await loadingController.create({ spinner: 'crescent', message: 'Actualizando maestros...' })
    await loading.present()

    await syncStore.fillVersions()
    await syncStore.fillSyncState()

    await loading.dismiss()
  } else {
    controlStore.$patch({
      error: 'Para poder realizar una sincronización de datos es necesario tener una conexión a internet activa'
    })
  }
}

const cancel = () => modalController.dismiss(null, 'cancel')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(IonicIcon, {
                  icon: "arrowBackOutline",
                  onClick: cancel
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), { class: "ion-padding" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonList), {
          lines: "none",
          class: "versions"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(syncStore).versions, (version) => {
              return (_openBlock(), _createBlock(_unref(IonItem), {
                key: version.table
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonText), { color: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(version.label), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("p", _hoisted_2, [
                        _createTextVNode(" Versión: " + _toDisplayString(version.version) + " - ", 1),
                        _createElementVNode("span", _hoisted_3, "Total: " + _toDisplayString(version.count), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(IonButton), {
            color: "primary",
            expand: "block",
            onClick: syncData
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})